<div class="container-fluid well zonal-edit">
    @if (loading) {
        <div class="loading"></div>
    }

    <div class="well-title">
        <div class="col-md-12">Edit Zonal Template</div>
    </div>

    <div class="col-md-12">
        <a class="back-link" [routerLink]="['/configure/zonaltemplate']">Back to template list.</a>
        <div style="padding-top: 15px"></div>
    </div>

    <div class="col-md-12">
        <div class="zonal-toolbar">
            <div class="btn-group pull-left" role="group">
                <button title="Adds a new page" (click)="openAddPage()" class="btn btn-default tool-option">
                    <span nz-icon nzType="plus-circle"></span>
                </button>
                @if (selectedPageId != null) {
                    <button (click)="saveRegions()" title="Saves the current page" class="btn btn-default tool-option">
                        <span nz-icon nzType="save"></span>
                    </button>
                }
                @if (selectedPageId != null) {
                    <button
                        (click)="openEditPage()"
                        title="Edits the current page number"
                        class="btn btn-default tool-option">
                        <span nz-icon nzType="edit"></span>
                    </button>
                }
                @if (selectedPageId != null) {
                    <button (click)="deletePage()" title="Deletes the current page" class="btn btn-danger tool-option">
                        <span nz-icon nzType="close"></span>
                    </button>
                }
            </div>

            <div class="btn-group pull-left" role="group" style="padding-left: 10px">
                <button
                    (click)="changeRegionDrawType(regionTypeDoctype)"
                    title="Sets region tool to document type text"
                    class="btn tool-option zonal-tool-yellow"
                    [class.active]="regionDrawingType === regionTypeDoctype">
                    <span nz-icon nzType="aim"></span>
                </button>
                <button
                    (click)="changeRegionDrawType(regionTypeMetadata)"
                    title="Sets region tool to metadata"
                    class="btn btn-success tool-option"
                    [class.active]="regionDrawingType === regionTypeMetadata">
                    <span nz-icon nzType="aim"></span>
                </button>
                <button
                    (click)="changeRegionDrawType(regionTypeDoctypeImage)"
                    title="Sets region tool to document type image"
                    class="btn tool-option zonal-tool-blue"
                    [class.active]="regionDrawingType === regionTypeDoctypeImage">
                    <span nz-icon nzType="aim"></span>
                </button>
            </div>

            <div class="btn-group pull-right" role="group">
                @for (page of pages; track page) {
                    <button
                        (click)="changePage(page.ZonalTemplatePageID)"
                        [ngClass]="pageButtonClass[page.ZonalTemplatePageID]">
                        Page {{ page.ZonalPageNumber }}
                    </button>
                }
            </div>
        </div>
    </div>

    <div class="col-md-12"><div style="padding-top: 15px"></div></div>

    @if (selectedPageId != null) {
        <div class="col-md-12" style="margin-left: 30px">
            <div
                class="zonal-canvas"
                [style.width.px]="imageWidth"
                [style.height.px]="imageHeight"
                (pointerdown)="onCanvasPointerDown($event)"
                (pointermove)="onCanvasPointerMove($event)"
                (pointerup)="onCanvasPointerUp()"
                (pointerleave)="onCanvasPointerUp()">
                @if (imageUrl) {
                    <img
                        [src]="imageUrl"
                        (load)="onImageLoad()"
                        class="zonal-image"
                        [style.width.px]="imageWidth"
                        [style.height.px]="imageHeight"
                        draggable="false" />
                }
                <!-- region overlays -->
                @for (region of regions; track region) {
                    <div
                        [appZonalRegion]="region.box"
                        (boxChange)="onRegionBoxChange(region, $event)"
                        [ngClass]="region.cssClass"
                        class="zonal-region">
                        <button
                            (click)="removeRegion(region.regionID)"
                            title="Deletes the region"
                            class="smallbtn tool-button zonal-region-btn">
                            <span nz-icon nzType="close"></span>
                        </button>
                        @if (region.regionType !== regionTypeDoctype && region.regionType !== regionTypeDoctypeImage) {
                            <button
                                (click)="editRegion(region)"
                                title="Edits the region"
                                class="smallbtn tool-button zonal-region-btn">
                                <span nz-icon nzType="edit"></span>
                            </button>
                        }
                        <span class="zonal-resize-grip"></span>
                    </div>
                }
                <!-- live draw preview -->
                @if (drawing && drawBox) {
                    <div
                        class="zonal-draw-preview"
                        [style.left.px]="drawBox.x"
                        [style.top.px]="drawBox.y"
                        [style.width.px]="drawBox.width"
                        [style.height.px]="drawBox.height"></div>
                }
            </div>
        </div>
    }
</div>

<!-- add page modal -->
<nz-modal [(nzVisible)]="addPageVisible" nzTitle="Add Page" (nzOnCancel)="addPageVisible = false" [nzFooter]="null">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="addPageForm" (ngSubmit)="addPage()">
            <nz-form-item>
                <nz-form-label>Image/PDF</nz-form-label>
                <nz-form-control>
                    <input type="file" (change)="onAddPageFileChange($event)" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Page Number</nz-form-label>
                <nz-form-control>
                    <nz-input-number formControlName="pageNumber" [nzMin]="1" [nzStep]="1" nzPlaceHolder="Automatic">
                    </nz-input-number>
                </nz-form-control>
            </nz-form-item>
            <button nz-button nzType="primary" type="submit">Add Page</button>
        </form>
    </ng-container>
</nz-modal>

<!-- edit page modal -->
<nz-modal [(nzVisible)]="editPageVisible" nzTitle="Edit Page" (nzOnCancel)="editPageVisible = false" [nzFooter]="null">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="editPageForm" (ngSubmit)="editPage()">
            <nz-form-item>
                <nz-form-label nzRequired>Page Number</nz-form-label>
                <nz-form-control nzErrorTip="Enter a valid page number">
                    <nz-input-number formControlName="pageNumber" [nzMin]="1" [nzStep]="1"></nz-input-number>
                </nz-form-control>
            </nz-form-item>
            <button nz-button nzType="primary" type="submit">Edit Page</button>
        </form>
    </ng-container>
</nz-modal>

<!-- edit metadata region modal -->
<nz-modal
    [(nzVisible)]="editRegionVisible"
    nzTitle="Edit Region"
    (nzOnCancel)="editRegionVisible = false"
    [nzFooter]="null">
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="editRegionForm" (ngSubmit)="saveEditRegion()">
            <nz-form-item>
                <nz-form-label>Mapped Metadata</nz-form-label>
                <nz-form-control>
                    <nz-select
                        formControlName="metaDataDefinitionID"
                        nzShowSearch
                        nzAllowClear
                        nzPlaceHolder="None"
                        style="width: 100%">
                        @for (md of metaDataDefinitions; track md) {
                            <nz-option
                                [nzValue]="md.MetaDataDefinitionID"
                                [nzLabel]="md.MetaDataDefinitionName"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <button nz-button nzType="primary" type="submit">Save</button>
        </form>
    </ng-container>
</nz-modal>
